module.exports = __webpack_public_path__ + "img/bed4844895658fd1b5c10078b6f48f70.png";